<p-dialog
  [(visible)]="showInstructions"
  [modal]="true"
  [resizable]="false"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [style]="{ 'min-width': '500px', 'min-height': '300px' }"
>
  <ng-template #header>
    <h2 class="flex align-items-center m-0">Instructions</h2>
  </ng-template>
  <ng-template #content>
    <p>To start the UI chat, run the eFAACT_Angular_Query exe file.</p>
    <p>
      If you have added files to the directory and want them to be added to the
      database run the eFAACT_Ingestion exe file. Once the exe has finished
      loading do the following:
    </p>
    <ul>
      <li>Open a command prompt.</li>
      <li>
        Paste this command to add the files to the database:
        <code>
          Invoke-RestMethod -Uri "http://127.0.0.1:8000/process-directories" `
          -Method POST `
          -ContentType "application/json" `
          -Body '&#123;&#125;'
        </code>
      </li>
      <li>
        Paste this command to add the website data to the database:
        <code>
          Invoke-RestMethod -Uri "http://127.0.0.1:8000/process-websites" `
          -Method POST `
          -ContentType "application/json" `
          -Body '&#123;&#125;'
        </code>
      </li>
    </ul>
  </ng-template>
</p-dialog>

<div
  class="chat-shell"
  [class.chat-shell--floating]="floatingPanel"
  [class.chat-shell--page]="!floatingPanel"
>
  <header class="chat-header">
    <div class="chat-header-brand">
      <div class="chat-header-avatar" aria-hidden="true">
        <img src="../../../../images/efaact_ai_logo.png" alt="" style="width: 35px; height: 35px;">
      </div>
      <div class="chat-header-copy">
        <h2 class="chat-header-title">eFAACT Expert</h2>
        <p class="chat-header-subtitle">AI expert for your eFAACT questions</p>
      </div>
    </div>
    <div class="chat-header-actions">
      <button
        pButton
        type="button"
        label="Clear"
        icon="pi pi-trash"
        text
        rounded
        severity="secondary"       
        (click)="clearChat()"
        [disabled]="!messages.length && !error"
      ></button>
      <button
        *ngIf="floatingPanel"
        pButton
        type="button"
        icon="pi pi-times"
        rounded
        text
        severity="secondary"
        class="floating-chat-close"
        (click)="onCloseFloatingPanel()"
        aria-label="Close chat"
        title="Close chat"
      ></button>
    </div>
  </header>

  <div class="messages-container" #messageContainer>
    <div *ngIf="messages.length === 0 && !isLoading" class="empty-state">
      <div class="empty-state-icon" aria-hidden="true">
        <i class="pi pi-sparkles"></i>
      </div>
      <h3 class="empty-state-title">How can I help?</h3>
      <p class="empty-state-text">
        Ask me about setup, features, or how to accomplish your tasks in eFAACT.
      </p>
    </div>

    <div
      *ngFor="let message of messages"
      #messageEl
      class="message-row"
      [class.message-row--user]="message.role === 'user'"
      [class.message-row--assistant]="message.role === 'assistant'"
    >
      <div
        *ngIf="message.role === 'assistant'"
        class="message-avatar message-avatar--assistant"
        aria-hidden="true"
      >
        <i class="pi pi-sparkles text-white" aria-hidden="true"></i>
      </div>

      <div class="message-bubble">
        <div
          class="message-text"
          [innerHTML]="formatMessage(message.content) | safe: 'html'"
        ></div>
        <time class="message-time">{{
          message.timestamp | date: 'shortTime'
        }}</time>
      </div>

      <div
        *ngIf="message.role === 'user'"
        class="message-avatar message-avatar--user"
        aria-hidden="true"
      >
        <i class="pi pi-user"></i>
      </div>
    </div>

    <div *ngIf="isLoading" class="message-row message-row--assistant">
      <div class="message-avatar message-avatar--assistant" aria-hidden="true">
        <!-- <img src="../../../../images/efaact_ai_logo.png" alt="" /> -->
        <i class="pi pi-sparkles text-white" aria-hidden="true"></i>
      </div>
      <div class="message-bubble message-bubble--loading">
        <div class="typing-indicator" aria-label="Assistant is typing">
          <span></span><span></span><span></span>
        </div>
        <span class="typing-label">Thinking…</span>
      </div>
    </div>
  </div>

  <div *ngIf="error" class="chat-error" role="alert">
    <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
    <span class="chat-error-text">{{ error }}</span>
    <button
      pButton
      type="button"
      icon="pi pi-times"
      [rounded]="true"
      [text]="true"
      severity="danger"
      size="small"
      (click)="error = null"
      aria-label="Dismiss error"
    ></button>
  </div>

  <footer class="chat-composer">
    <textarea
      pTextarea
      class="composer-input"
      [(ngModel)]="currentQuery"
      (keydown)="onComposerKeydown($event)"
      placeholder="Message eFAACT Expert…"
      [disabled]="isLoading"
      rows="1"
      [autoResize]="true"
    ></textarea>
    <button
      pButton
      type="button"
      icon="pi pi-send"
      [rounded]="true"
      class="composer-send"
      [disabled]="!currentQuery.trim() || isLoading"
      (click)="sendMessage()"
      aria-label="Send message"
      title="Send message"
    ></button>
  </footer>
</div>
